import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fbd6ebe"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "spacer" }, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "13" })
], -1))
const _hoisted_2 = { class: "proposal-list__content__table__item__details__cell proposal-list__content__table__item__details__cell--expand" }
const _hoisted_3 = { class: "proposal-list__content__table__item__details__cell proposal-list__content__table__item__details__cell--client" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "proposal-list__content__table__item__details__cell proposal-list__content__table__item__details__cell--number" }
const _hoisted_6 = { class: "proposal-list__content__table__item__details__cell proposal-list__content__table__item__details__cell--status" }
const _hoisted_7 = { class: "proposal-list__content__table__item__details__cell proposal-list__content__table__item__details__cell--created-by" }
const _hoisted_8 = { class: "proposal-list__content__table__item__details__cell proposal-list__content__table__item__details__cell--requested-by" }
const _hoisted_9 = { class: "proposal-list__content__table__item__details__cell proposal-list__content__table__item__details__cell--created" }
const _hoisted_10 = { class: "proposal-list__content__table__item__details__cell proposal-list__content__table__item__details__cell--sent" }
const _hoisted_11 = { class: "proposal-list__content__table__item__details__cell proposal-list__content__table__item__details__cell--approved" }
const _hoisted_12 = { class: "proposal-list__content__table__item__details__cell proposal-list__content__table__item__details__cell--rejected" }
const _hoisted_13 = { class: "proposal-list__content__table__item__details__cell proposal-list__content__table__item__details__cell__actions" }
const _hoisted_14 = { class: "proposal-list__content__table__item__details__cell__actions__action" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "13",
    class: "proposal-list__content__table__item__divider"
  }, [
    /*#__PURE__*/_createElementVNode("hr")
  ])
], -1))
const _hoisted_16 = { class: "proposal-list__content__table__item__menu" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_18 = { colspan: "12" }
const _hoisted_19 = { class: "flex flex-row w-full justify-between items-center" }
const _hoisted_20 = {
  key: 0,
  class: "block"
}
const _hoisted_21 = { class: "block" }
const _hoisted_22 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_expand_button = _resolveComponent("expand-button")!
  const _component_proposal_status = _resolveComponent("proposal-status")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_proposal_row_actions = _resolveComponent("proposal-row-actions")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("tr", {
      class: "proposal-list__content__table__item pointer",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isExpanded = !_ctx.isExpanded))
    }, [
      _createElementVNode("td", _hoisted_2, [
        _createVNode(_component_expand_button, {
          modelValue: _ctx.isExpanded,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isExpanded) = $event)),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isExpanded = !_ctx.isExpanded))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("td", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.proposal.customer.name) + " ", 1),
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.proposal.suppliers?.map((item) => item["fullName"]).join(', ')), 1)
      ]),
      _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.$t('proposal.list.content.table.body.proposal_number', {number: _ctx.proposal.id})), 1),
      _createElementVNode("td", _hoisted_6, [
        _createVNode(_component_proposal_status, {
          type: _ctx.status,
          changed: _ctx.changed
        }, null, 8, ["type", "changed"])
      ]),
      _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.proposal.createdBy), 1),
      _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.proposal.requestedBy), 1),
      _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.createdAt), 1),
      _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.sentAt), 1),
      _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.approvedAt), 1),
      _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.rejectedAt), 1),
      _createElementVNode("td", {
        class: _normalizeClass(["proposal-list__content__table__item__details__cell proposal-list__content__table__item__details__cell--valid-from", { 'date-expired': _ctx.isExpired }])
      }, _toDisplayString(_ctx.validFrom), 3),
      _createElementVNode("td", {
        class: _normalizeClass(["proposal-list__content__table__item__details__cell proposal-list__content__table__item__details__cell--valid-till", { 'date-expired': _ctx.isExpired }])
      }, _toDisplayString(_ctx.validTo), 3),
      _createElementVNode("td", _hoisted_13, [
        _createElementVNode("span", _hoisted_14, [
          _createVNode(_component_router_link, {
            to: {name: 'proposal.show', params: {clientId: _ctx.proposal.customer.id, proposalId: _ctx.proposal.id}}
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", null, [
                _createElementVNode("span", {
                  class: _normalizeClass(["icon", _ctx.isProposalEditable ? 'icon-edit' : 'icon-show'])
                }, null, 2)
              ])
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ]),
    (_ctx.isExpanded)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_15,
          _createElementVNode("tr", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("td", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, [
                (_ctx.updatedAt)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.proposal.description), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('proposal.list.content.table.body.last_edit', {updatedBy: _ctx.proposal.updatedBy, updatedAt: _ctx.updatedAt})), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_22, [
                  _createVNode(_component_proposal_row_actions, {
                    proposal: _ctx.proposal,
                    onProposalDelete: _ctx.handleProposalDelete
                  }, null, 8, ["proposal", "onProposalDelete"])
                ])
              ])
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_modal, {
      type: "warning",
      modelValue: _ctx.showWarningModal,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showWarningModal) = $event)),
      onConfirmClick: _ctx.handleDeleteConfirmClick
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('proposal.list.content.warning.title', {id: _ctx.proposal.id})), 1)
      ]),
      default: _withCtx(() => [
        _createTextVNode(" " + _toDisplayString(_ctx.$t('proposal.list.content.warning.content')), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "onConfirmClick"])
  ], 64))
}